var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dot-label-root",class:{
    'dot-label-small': _vm.size === 'small',
    'dot-label-medium': _vm.size === 'medium',
    'dot-label-large': _vm.size === 'large',
}},[_c('i',{staticClass:"dot-label-icon",class:_vm.icon,style:(_vm.iconStyle)}),_c('span',{staticClass:"dot-label-text"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }